import { getImageEntries } from './images';
import { Author } from './interfaces';
import { getLinkObjectFromTeaser } from './link';

function getAuthor(author: any) : Author | null {
  if(author) {
    let entry: Author = {
      id: author.id || null,
      email: author.email || null,
      firstName: author.firstname || null,
      lastName: author.lastname || null,
      name: author.fullName || author.name || null,
      shortName: author.shortName || null,
      ressort: author.ressort || null,
      images: getImageEntries(author),
      links: author.links ?? []
    }
    return entry
  }
  return null
}

export function getAuthors(entry: any) : Author[] {
  let authors: Author[] = []
  if(entry.authors && entry.authors.length > 0) {
    entry.authors.forEach(element => {
      let author: Author | null = getAuthor(element)
      if(author) {
        authors.push(author)
      }
    });
  }
  else if(entry.author) {
    let author: Author = {
      id: entry.author.id || null,
      email: entry.author.email || null,
      firstName: entry.author.firstname || null,
      lastName: entry.author.lastname || null,
      name: entry.author.fullName || entry.author.name || null,
      ressort: entry.author.ressort || null,
      images: getImageEntries(entry.author),
      links: entry.author.links ?? []
    }
    authors.push(author)
  }
  return authors
}

export function getAuthorName(author: Author) : string | null {
  if(author && author.shortName) {
    return author.shortName
  }
  let authorName: string | null = null
  if(!author?.shortName && author && author.firstName) {
    authorName = author.firstName
  }
  if(!author?.shortName && author && author.lastName) {
    if(authorName) {
      authorName += " "
    }
    authorName += author.lastName
  }
  return authorName
}

export function getAuthorNames(authors: Author[]) : string | null {
  let names: string[] = []
  if(authors && authors.length > 0) {
    authors.forEach(element => {
      let name: string | null = getAuthorName(element)
      if(name) {
        names.push(name)
      }
    });
  }
  if(names && names.length == 1) {
    return names[0]
  }
  else if(names && names.length == 2) {
    return `${names[0]} und ${names[1]}`
  }
  else if(names && names.length > 2) {
    let name = ""
    for(let i = 0; i < names.length - 2; i++) {
      name += names[i] + ", "
    }
    name += names[names.length - 2] + " und " + names[names.length - 1]
    return name
  }
  
  return ''
}